// extracted by mini-css-extract-plugin
export default {"body":"PopupBodyComponent_body__sb1yM","body_large":"PopupBodyComponent_body_large__mhiBv"};